import { Briefcase, Store, Heart, Coins, GraduationCap, Plane, Users, Home, HeartPulse, CalendarDays, Orbit, Hand } from "lucide-react";

export const CATEGORY_ICONS = {
  Briefcase, Store, Heart, Coins, GraduationCap, Plane,
  Users, Home, HeartPulse, CalendarDays, Orbit, Hand,
};

export const FILTER_KEYS = [
  "all", "astrology", "kundli", "palmistry", "career", "marriage",
  "business", "finance", "education", "foreign", "family", "property", "forecast",
];
